import { render, staticRenderFns } from "./SearchingSolshareFailedNotFound.vue?vue&type=template&id=247f1502&scoped=true"
import script from "./SearchingSolshareFailedNotFound.vue?vue&type=script&lang=js"
export * from "./SearchingSolshareFailedNotFound.vue?vue&type=script&lang=js"
import style0 from "./SearchingSolshareFailedNotFound.vue?vue&type=style&index=0&id=247f1502&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247f1502",
  null
  
)

export default component.exports